import { render, staticRenderFns } from "./TermsCondition.vue?vue&type=template&id=484f8522"
import script from "./TermsCondition.vue?vue&type=script&lang=js"
export * from "./TermsCondition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports